module.exports = __webpack_public_path__ + "static/img/interrogacao.2e606912.svg";